
<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block" [class.component-dark-theme]="isToggled">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mb-0">
        Kreiranje Obavijesti
      </h5>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="notificationForm" (ngSubmit)="onSubmit()">

      <mat-form-field class="mb-25">
        <mat-label>Naziv Obavijesti</mat-label>
        <input matInput formControlName="title">
      </mat-form-field>

      <mat-form-field class="mb-25">
        <mat-label>Poruka</mat-label>
        <textarea matInput formControlName="message"></textarea>
      </mat-form-field>

      <mat-form-field class="mb-25">
        <mat-label>Udruge</mat-label>
        <mat-select formControlName="associationIds" multiple>
          @for (association of associations; track association) {
            <mat-option [value]="association.id">
              {{ association.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="mb-25">
        <mat-label>Kanali Dostave</mat-label>
        <mat-select formControlName="deliveryChannelIds" multiple>
          @for (channel of deliveryChannels; track channel) {
            <mat-option [value]="channel.id">
              {{ channel.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <app-file-upload
        [storageLocation]="notificationForm.get('fileStorageLocation')?.value">
      </app-file-upload>

      <button style="margin-top: 20px;" mat-raised-button color="primary" type="submit" [disabled]="notificationForm.invalid">
        Kreiraj
      </button>
    </form>
  </mat-card-content>

</mat-card>